module.exports = __webpack_public_path__ + "img/swift-logo.e47b7186.svg";